var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatterboxLogoHuge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 773,
    height: 773,
    viewBox: "0 0 773 773",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M772.998 386.501L386.499 0.00109863L-0.000488281 386.501L386.499 773L772.998 386.501ZM367.063 699.508V432.26L233.444 565.889L367.063 699.508ZM206.416 538.861L340.031 405.243H72.7982L206.416 538.861ZM73.5342 367.02H340.039L206.785 233.77L73.5342 367.02ZM233.812 206.742L367.063 339.996V73.4914L233.812 206.742ZM539.231 566.216L405.286 700.161V432.268L539.231 566.216ZM566.259 539.189L432.31 405.243H700.204L566.259 539.189ZM699.468 367.02H432.303L565.891 233.442L699.468 367.02ZM538.863 206.415L405.286 339.988V72.838L538.863 206.415Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatterboxLogoHuge);
export default __webpack_public_path__ + "static/media/chatterbox-logo_huge.d1b903789cb775c0212733d0d765123f.svg";
export { ForwardRef as ReactComponent };